/* unplugin-vue-components disabled */import script from "./PDFRender.vue?vue&type=script&lang=ts&setup=true"
export * from "./PDFRender.vue?vue&type=script&lang=ts&setup=true"

import "./PDFRender.vue?vue&type=style&index=0&id=2478723f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2478723f"]])

export default __exports__